import axios from '../../../../../api/axios';

export const initialState = {
  insuranceSubtraction: {},
  insuranceSubtractions: [],
  error: {},
  isLoaded: false,
  page: null,
};

export const reducer = (state, actions) => {
  const { payload, type } = actions;
  switch (type) {
    case 'LOADED':
      return { ...state, isLoaded: true };
    case 'LOADING':
      return { ...state, isLoaded: false };
    case 'CHANGE_PAGE':
      return { ...state, page: payload };
    case 'CHANGE_FIELD':
      const { name, value } = payload;
      return {
        ...state,
        insuranceSubtraction: { ...state.insuranceSubtraction, [name]: value },
      };
    case 'ERROR':
      return { ...state, error: payload };
    case 'ISS':
      return { ...state, insuranceSubtractions: payload, isLoaded: true };
    case 'IS':
      return { ...state, insuranceSubtraction: payload };
    case 'ISS_WITH_RESET_FORM':
      return {
        ...initialState,
        insuranceSubtractions: payload,
        isLoaded: true,
      };
    case 'RESET_FORM':
      return {
        ...initialState,
        insuranceSubtractions: state.insuranceSubtractions,
        isLoaded: true,
      };
    default:
      return state;
  }
};

export const actions = {
  fetchingIS: async (page = 1, limit) => {
    try {
      const { data: iss } = await axios.get(
        `/api/v1/admin/insuranceSubtractions/list/${page}/${limit}`
      );
      return iss;
    } catch (error) {
      return new Error(error);
    }
  },
  deleteIS: async (id) => {
    try {
      const {
        data: { messages },
      } = await axios.delete(`/api/v1/admin/insuranceSubtractions/${id}`);
      return messages;
    } catch (error) {
      return new Error(error);
    }
  },
};
